import { useState } from "react";
import React, { Component } from "react";

import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Upload,
  Dropdown,
  Menu,
  Select,
  Card,
  Form,
  Tree,
  Checkbox,
} from "antd";
import {
  DownOutlined,
  FrownFilled,
  FrownOutlined,
  MehOutlined,
  SmileOutlined,
  SoundOutlined,
  UsergroupAddOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Translation } from "react-i18next";
import i18next from "i18next";
const { Option } = Select;
function DynamicForm(props) {
  const { getFieldDecorator } = props.form;
  const [validateChoiceValue, setValidateChoiceValue] = useState("success");

  const handleFormChange = (index, value, option, name) => {
    let data = [...props.inputFields];
    data[index][name] = name == "choiceValue" ? value.target.value : value;
    props.handleChanges(data);
  };
  const [selectedGroup, setSelectedGroup] = useState("1");
  const [selectedVoice, setSelectedVoice] = useState("1");
  const [selectedAction, setSelectedAction] = useState("1");

  const handleSelectedGroup = (index, value) => {
    setSelectedGroup(value);
  };
  const handleSelectedVoice = (index, value) => {
    setSelectedVoice(value);
  };
  const handleSecondActionsValue = (value) => {
    setSelectedAction(value);
  };
  const addFields = () => {
    // if (props.inputFields.length == 13) {
    //   return;
    // }
    let newfield = {
      choiceValue: "",
      actionValue: "2",
      groupValue: 0,
      voiceValue: 0,
      waitingValue: -1,
      interrupt: false,
    };

    props.handleChanges([...props.inputFields, newfield]);

    // setInputFields([...inputFields, newfield]);
  };
  return (
    <Translation>
      {(t) => (
        <>
          {/* <form>
        {inputFields.map((input, index) => {
          return (
            <div key={index}>
              <input
                name="name"
                placeholder="Name"
                onChange={(event) => handleFormChange(index, event)}
                value={input.name}
              />
              <input
                name="age"
                placeholder="Age"
                value={input.age}
                onChange={(event) => handleFormChange(index, event)}
              />
            </div>
          );
        })}
      </form> */}
          <Form layout="inline">
            {/* <Form.Item>
          <Button onClick={addFields}>
            <PlusOutlined />
          </Button>
        </Form.Item> */}
            {props.inputFields.map((input, index) => {
              return (
                <>
                  <Form.Item
                    style={{ visibility: index == 0 ? "visible" : "hidden" }}
                  >
                    <Button
                      onClick={addFields}
                      disabled={props.inputFields.length == 12}
                    >
                      <PlusOutlined />
                    </Button>
                  </Form.Item>
                  <Form.Item
                    label={t("Choice")}
                    key={index}
                    validateStatus={validateChoiceValue}
                    help={
                      validateChoiceValue == "error"
                        ? t("Should be number or * or #")
                        : null
                    }
                  >
                    <Input
                      status="error"
                      placeholder={t("Enter Choice")}
                      onChange={(event) => {
                        let option = {};

                        handleFormChange(index, event, option, "choiceValue");
                        setValidateChoiceValue(
                          /^([0-9*#]{1})$/.test(event.target.value)
                            ? "success"
                            : "error"
                        );
                        props.toggleAddToCallFlowButton(
                          /^([0-9*#]{1})$/.test(event.target.value)
                        );
                      }}
                      name="choiceInput"
                      maxLength={1}
                    />
                  </Form.Item>
                  <Form.Item label={t("Pick Action")} key={index}>
                    <Select
                      name="action"
                      value={input.actionValue}
                      onChange={(event, option) => {
                        handleFormChange(index, event, option, "actionValue");
                      }}
                    >
                      <Option value="2">{t("Transfer To")}</Option>
                      <Option value="1">{t("Play Voice")}</Option>
                    </Select>
                  </Form.Item>
                  {input.actionValue == "2" ? (
                    <>
                      <Form.Item label={t("Group Name")} key={index}>
                        <Select
                          name="group"
                          value={input.groupValue}
                          onChange={(event, option) =>
                            handleFormChange(index, event, option, "groupValue")
                          }
                          style={{ width: "100%" }}
                        >
                          {props.agentGroups.map((input, index1) => {
                            return (
                              <Option key={index} value={index1}>
                                {input.groupName}
                              </Option>
                            );
                          })}
                          {/* <Option value="1">Group1</Option>
                      <Option value="2">Group2</Option> */}
                        </Select>
                      </Form.Item>
                      <Form.Item label={t("Waiting Message")} key={index}>
                        <Select
                          name="voice"
                          value={input.waitingValue}
                          onChange={(event, option) =>
                            handleFormChange(
                              index,
                              event,
                              option,
                              "waitingValue"
                            )
                          }
                        >
                          <Option value={-1}>Select Message</Option>
                          {props.prompts.map((input, index1) => {
                            return (
                              <Option key={index} value={index1}>
                                {input.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <br></br>
                    </>
                  ) : (
                    <>
                      <Form.Item label={t("Voice Message")} key={index}>
                        <Select
                          name="voice"
                          value={input.voiceValue}
                          onChange={(event, option) =>
                            handleFormChange(index, event, option, "voiceValue")
                          }
                        >
                          {props.prompts.map((input, index1) => {
                            return (
                              <Option key={index} value={index1}>
                                {input.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item label={t("Interrupt on DTMF")} key={index}>
                        <Checkbox
                          checked={input.interrupt}
                          onChange={(event, option) => {
                            let value = event.target.checked;
                            handleFormChange(index, value, option, "interrupt");
                          }}
                        ></Checkbox>
                      </Form.Item>
                      <br></br>
                    </>
                  )}
                </>
              );
            })}
          </Form>
        </>
      )}
    </Translation>
  );
}

export default DynamicForm;
